// 科普文章数据
// 包含所有9个分类，每个分类5篇文章，共45篇

// 引入默认封面图片
import imgDefaultCover from '@/h5/doucan/assets/shunyi/img_default_cover_article.png'

// 分类配置
export const categories = [
  { key: 'basic_knowledge', label: '基础知识' },
  { key: 'early_detection', label: '早期发现' },
  { key: 'prevention', label: '预防保健' },
  { key: 'treatment', label: '治疗方法' },
  { key: 'rehabilitation', label: '康复训练' },
  { key: 'expert_advice', label: '专家建议' },
  { key: 'case_study', label: '案例分享' },
  { key: 'home_care', label: '家庭护理' },
  { key: 'faq', label: '常见问题' }
]

// 生成文章基础内容的函数
function generateArticleContent(article) {
  const categoryLabels = {
    'basic_knowledge': '基础知识',
    'early_detection': '早期发现',
    'prevention': '预防保健',
    'treatment': '治疗方法',
    'rehabilitation': '康复训练',
    'expert_advice': '专家建议',
    'case_study': '案例分享',
    'home_care': '家庭护理',
    'faq': '常见问题'
  }

  return `
    <div class="article-intro">
      <h2>导读</h2>
      <p>${article.summary}</p>
    </div>

    <h2>核心要点</h2>
    <ul>
      <li>掌握${article.title}的基本概念和重要性</li>
      <li>了解相关的科学知识和实践方法</li>
      <li>学习如何在日常生活中应用这些知识</li>
      <li>获取专业的指导建议和注意事项</li>
    </ul>

    <h2>详细内容</h2>
    <p>脊柱侧弯是青少年时期常见的脊柱发育问题，${article.title}是脊柱侧弯防治体系中的重要环节。通过系统学习和正确应用相关知识，可以有效帮助患者改善症状、提高生活质量。</p>

    <h3>一、为什么重要</h3>
    <p>${article.title}对于脊柱侧弯的防治具有重要意义。早期识别和及时干预可以显著改善预后，避免病情进一步发展。研究表明，通过科学的方法和持之以恒的努力，大部分轻中度脊柱侧弯都能得到有效控制。</p>

    <h3>二、主要方法</h3>
    <p>针对${article.title}，专业团队通常会采用综合性的治疗方案，包括：</p>
    <ul>
      <li><strong>专业评估：</strong>通过详细的体格检查和影像学评估，全面了解患者的脊柱状况</li>
      <li><strong>个性化方案：</strong>根据患者的具体情况制定针对性的康复计划</li>
      <li><strong>规律训练：</strong>坚持进行专业指导下的康复训练</li>
      <li><strong>定期随访：</strong>定期复查评估治疗效果并及时调整方案</li>
    </ul>

    <h3>三、实施要点</h3>
    <p>在实施过程中，需要特别注意以下几个方面：</p>
    <ol>
      <li><strong>规范性：</strong>严格按照专业指导进行，确保动作的正确性</li>
      <li><strong>持续性：</strong>康复训练需要长期坚持，不能三天打鱼两天晒网</li>
      <li><strong>循序渐进：</strong>训练强度要逐步提升，避免过度训练</li>
      <li><strong>多方配合：</strong>患者、家长、治疗师要密切配合</li>
    </ol>

    <h3>四、注意事项</h3>
    <p>在关注${article.title}的过程中，要避免以下常见误区：</p>
    <ul>
      <li>不要盲目追求快速见效，康复是一个循序渐进的过程</li>
      <li>不要自行设计训练方案，应在专业人士指导下进行</li>
      <li>不要忽视心理健康，适度的心理支持同样重要</li>
      <li>不要轻信偏方秘方，应选择科学的治疗方法</li>
    </ul>

    <h2>专家提醒</h2>
    <div class="expert-reminder">
      <p><strong>重要提示：</strong>每个患者的情况都不相同，${article.title}需要个性化的方案。建议在专业医师或康复师的指导下进行，定期评估效果并及时调整治疗方案。</p>
    </div>

    <h2>总结</h2>
    <p>${article.title}是脊柱侧弯防治的重要组成部分。通过系统学习和正确实践，配合专业团队的指导，大多数患者都能取得满意的治疗效果。记住，早发现、早干预、坚持治疗是成功的关键。</p>

    <div class="action-tips">
      <h3>下一步行动</h3>
      <ul>
        <li>如有疑问，建议咨询专业的脊柱外科或康复科医生</li>
        <li>定期进行脊柱健康检查，及时发现问题</li>
        <li>保持良好的生活习惯，注意日常姿势管理</li>
        <li>加入患者互助群，与其他家长交流经验</li>
      </ul>
    </div>
  `
}

// 文章列表数据
export const articlesList = [
  // 基础知识分类 - 5篇
  {
    id: 'basic_001',
    title: '什么是脊柱侧弯？',
    summary: '详细解读脊柱侧弯的定义、分类和形成原因，帮助家长和青少年正确认识脊柱侧弯。',
    category: 'basic_knowledge',
    date: '2024-10-28',
    image: imgDefaultCover
  },
  {
    id: 'basic_002',
    title: '脊柱侧弯的发展阶段',
    summary: '了解脊柱侧弯从轻度到重度的发展过程，掌握各阶段的特征和应对方法。',
    category: 'basic_knowledge',
    date: '2024-10-27',
    image: imgDefaultCover
  },
  {
    id: 'basic_003',
    title: '青少年特发性脊柱侧弯',
    summary: '青少年特发性脊柱侧弯是最常见的类型，了解其特点和发病规律。',
    category: 'basic_knowledge',
    date: '2024-10-26',
    image: imgDefaultCover
  },
  {
    id: 'basic_004',
    title: '脊柱侧弯的测量方法',
    summary: '介绍Cobb角测量方法和其他常用的脊柱侧弯评估工具。',
    category: 'basic_knowledge',
    date: '2024-10-25',
    image: imgDefaultCover
  },
  {
    id: 'basic_005',
    title: '脊柱侧弯对身体的影响',
    summary: '全面了解脊柱侧弯对身体各系统的潜在影响，重视早期干预。',
    category: 'basic_knowledge',
    date: '2024-10-24',
    image: imgDefaultCover
  },
  
  // 早期发现分类 - 5篇
  {
    id: 'early_001',
    title: '脊柱侧弯的早期症状识别',
    summary: '学会识别脊柱侧弯的早期信号，包括肩膀高低不平、肋骨突出等表现。',
    category: 'early_detection',
    date: '2024-10-23',
    image: imgDefaultCover
  },
  {
    id: 'early_002',
    title: '家庭自检方法',
    summary: '家长可以在家进行的简单筛查方法，包括前屈测试等基本检查。',
    category: 'early_detection',
    date: '2024-10-22',
    image: imgDefaultCover
  },
  {
    id: 'early_003',
    title: '学校筛查的重要性',
    summary: '了解学校脊柱侧弯筛查项目，把握最佳发现时机。',
    category: 'early_detection',
    date: '2024-10-21',
    image: imgDefaultCover
  },
  {
    id: 'early_004',
    title: '什么时候需要就医',
    summary: '识别需要专业医疗评估的情况，避免延误最佳治疗时机。',
    category: 'early_detection',
    date: '2024-10-20',
    image: imgDefaultCover
  },
  {
    id: 'early_005',
    title: '影像学检查指南',
    summary: '了解X光、CT、MRI等检查方法的适用情况和注意事项。',
    category: 'early_detection',
    date: '2024-10-19',
    image: imgDefaultCover
  },
  
  // 预防保健分类 - 5篇
  {
    id: 'prevention_001',
    title: '良好坐姿的培养',
    summary: '学习正确的坐姿习惯，从日常生活中预防脊柱问题。',
    category: 'prevention',
    date: '2024-10-18',
    image: imgDefaultCover
  },
  {
    id: 'prevention_002',
    title: '书包的正确背法',
    summary: '选择合适的书包并掌握正确的背负方式，保护脊柱健康。',
    category: 'prevention',
    date: '2024-10-17',
    image: imgDefaultCover
  },
  {
    id: 'prevention_003',
    title: '青少年日常运动建议',
    summary: '推荐适合青少年的运动项目，促进脊柱健康发育。',
    category: 'prevention',
    date: '2024-10-16',
    image: imgDefaultCover
  },
  {
    id: 'prevention_004',
    title: '睡眠姿势与床垫选择',
    summary: '了解有利于脊柱健康的睡眠姿势和床垫选择要点。',
    category: 'prevention',
    date: '2024-10-15',
    image: imgDefaultCover
  },
  {
    id: 'prevention_005',
    title: '营养与脊柱健康',
    summary: '合理的营养摄入对骨骼和脊柱发育的重要作用。',
    category: 'prevention',
    date: '2024-10-14',
    image: imgDefaultCover
  },
  
  // 治疗方法分类 - 5篇
  {
    id: 'treatment_001',
    title: '脊柱侧弯的治疗选择',
    summary: '全面介绍观察、支具治疗和手术等不同治疗方案的适应症。',
    category: 'treatment',
    date: '2024-10-13',
    image: imgDefaultCover
  },
  {
    id: 'treatment_002',
    title: '支具治疗全面解析',
    summary: '了解支具治疗的原理、类型、佩戴要求和注意事项。',
    category: 'treatment',
    date: '2024-10-12',
    image: imgDefaultCover
  },
  {
    id: 'treatment_003',
    title: '物理治疗的作用',
    summary: '物理治疗在脊柱侧弯管理中的重要地位和具体方法。',
    category: 'treatment',
    date: '2024-10-11',
    image: imgDefaultCover
  },
  {
    id: 'treatment_004',
    title: '手术治疗的时机',
    summary: '了解什么情况下需要考虑手术治疗，以及手术的类型和风险。',
    category: 'treatment',
    date: '2024-10-10',
    image: imgDefaultCover
  },
  {
    id: 'treatment_005',
    title: '中医康复方法',
    summary: '传统中医在脊柱侧弯康复中的应用，包括推拿、针灸等。',
    category: 'treatment',
    date: '2024-10-09',
    image: imgDefaultCover
  },
  
  // 康复训练分类 - 5篇
  {
    id: 'rehab_001',
    title: 'Schroth施罗特疗法介绍',
    summary: '详细介绍国际公认的脊柱侧弯专业康复方法——Schroth疗法。',
    category: 'rehabilitation',
    date: '2024-10-08',
    image: imgDefaultCover
  },
  {
    id: 'rehab_002',
    title: '核心肌群训练',
    summary: '加强核心肌群力量，为脊柱提供更好的支撑和稳定。',
    category: 'rehabilitation',
    date: '2024-10-07',
    image: imgDefaultCover
  },
  {
    id: 'rehab_003',
    title: '呼吸训练技巧',
    summary: '学习正确的呼吸方法，改善胸廓变形，提升康复效果。',
    category: 'rehabilitation',
    date: '2024-10-06',
    image: imgDefaultCover
  },
  {
    id: 'rehab_004',
    title: '居家康复动作指导',
    summary: '适合在家进行的康复训练动作，附详细图解和注意事项。',
    category: 'rehabilitation',
    date: '2024-10-05',
    image: imgDefaultCover
  },
  {
    id: 'rehab_005',
    title: '康复训练的常见误区',
    summary: '识别并避免康复训练中的常见错误，确保训练安全有效。',
    category: 'rehabilitation',
    date: '2024-10-04',
    image: imgDefaultCover
  },
  
  // 专家建议分类 - 5篇
  {
    id: 'expert_001',
    title: '康复专家谈脊柱侧弯管理',
    summary: '资深康复专家分享脊柱侧弯的综合管理策略和临床经验。',
    category: 'expert_advice',
    date: '2024-10-03',
    image: imgDefaultCover
  },
  {
    id: 'expert_002',
    title: '青春期侧弯的关键期管理',
    summary: '专家解读青春期快速生长期的脊柱侧弯管理要点。',
    category: 'expert_advice',
    date: '2024-10-02',
    image: imgDefaultCover
  },
  {
    id: 'expert_003',
    title: '家长最关心的十个问题',
    summary: '专家解答家长最常咨询的脊柱侧弯相关问题。',
    category: 'expert_advice',
    date: '2024-10-01',
    image: imgDefaultCover
  },
  {
    id: 'expert_004',
    title: '心理疏导的重要性',
    summary: '心理专家谈如何帮助侧弯青少年建立健康的心理状态。',
    category: 'expert_advice',
    date: '2024-09-30',
    image: imgDefaultCover
  },
  {
    id: 'expert_005',
    title: '长期随访与监测建议',
    summary: '专家指导如何进行有效的长期随访和定期监测。',
    category: 'expert_advice',
    date: '2024-09-29',
    image: imgDefaultCover
  },
  
  // 案例分享分类 - 5篇
  {
    id: 'case_001',
    title: '成功康复案例：小明的逆袭之路',
    summary: '一位15岁少年从30度侧弯到基本康复的真实经历分享。',
    category: 'case_study',
    date: '2024-09-28',
    image: imgDefaultCover
  },
  {
    id: 'case_002',
    title: '支具佩戴者的日常生活',
    summary: '一位佩戴支具的初中生分享她的学习生活和心路历程。',
    category: 'case_study',
    date: '2024-09-27',
    image: imgDefaultCover
  },
  {
    id: 'case_003',
    title: '家长陪伴康复的心得体会',
    summary: '一位母亲分享陪伴孩子康复两年的经验和感悟。',
    category: 'case_study',
    date: '2024-09-26',
    image: imgDefaultCover
  },
  {
    id: 'case_004',
    title: '手术后的康复历程',
    summary: '术后康复患者分享手术前后的身心变化和康复过程。',
    category: 'case_study',
    date: '2024-09-25',
    image: imgDefaultCover
  },
  {
    id: 'case_005',
    title: '运动与康复的完美结合',
    summary: '一位热爱运动的少年如何在康复中坚持训练的故事。',
    category: 'case_study',
    date: '2024-09-24',
    image: imgDefaultCover
  },
  
  // 家庭护理分类 - 5篇
  {
    id: 'home_001',
    title: '家庭康复环境的营造',
    summary: '如何在家中创造有利于康复训练的空间和氛围。',
    category: 'home_care',
    date: '2024-09-23',
    image: imgDefaultCover
  },
  {
    id: 'home_002',
    title: '支具的日常维护',
    summary: '支具的清洁、保养和常见问题处理方法。',
    category: 'home_care',
    date: '2024-09-22',
    image: imgDefaultCover
  },
  {
    id: 'home_003',
    title: '家长如何督促训练',
    summary: '帮助家长掌握有效督促孩子坚持康复训练的方法。',
    category: 'home_care',
    date: '2024-09-21',
    image: imgDefaultCover
  },
  {
    id: 'home_004',
    title: '家庭饮食调理建议',
    summary: '适合脊柱侧弯患者的营养搭配和饮食建议。',
    category: 'home_care',
    date: '2024-09-20',
    image: imgDefaultCover
  },
  {
    id: 'home_005',
    title: '家庭康复记录方法',
    summary: '教家长如何记录和追踪孩子的康复进展。',
    category: 'home_care',
    date: '2024-09-19',
    image: imgDefaultCover
  },
  
  // 常见问题分类 - 5篇
  {
    id: 'faq_001',
    title: '脊柱侧弯会遗传吗？',
    summary: '解答关于脊柱侧弯遗传性的常见疑问。',
    category: 'faq',
    date: '2024-09-18',
    image: imgDefaultCover
  },
  {
    id: 'faq_002',
    title: '侧弯会影响身高吗？',
    summary: '详细解释脊柱侧弯对身高的影响及相关因素。',
    category: 'faq',
    date: '2024-09-17',
    image: imgDefaultCover
  },
  {
    id: 'faq_003',
    title: '可以参加体育活动吗？',
    summary: '脊柱侧弯患者参加体育活动的指导和建议。',
    category: 'faq',
    date: '2024-09-16',
    image: imgDefaultCover
  },
  {
    id: 'faq_004',
    title: '多久复查一次？',
    summary: '不同程度侧弯的复查频率和随访建议。',
    category: 'faq',
    date: '2024-09-15',
    image: imgDefaultCover
  },
  {
    id: 'faq_005',
    title: '成年后还会继续恶化吗？',
    summary: '成年后脊柱侧弯的发展趋势和预后分析。',
    category: 'faq',
    date: '2024-09-14',
    image: imgDefaultCover
  }
]

// 为所有文章生成完整内容
export const articlesWithContent = articlesList.map(article => ({
  ...article,
  categoryLabel: categories.find(c => c.key === article.category)?.label || article.category,
  content: generateArticleContent(article)
}))

// 导出一个根据ID查找文章的函数
export function getArticleById(id) {
  return articlesWithContent.find(article => article.id === id) || null
}

// 导出根据分类查找文章的函数
export function getArticlesByCategory(categoryKey) {
  return articlesWithContent.filter(article => article.category === categoryKey)
}

export default {
  categories,
  articlesList,
  articlesWithContent,
  getArticleById,
  getArticlesByCategory
}

